import React, { SVGProps } from 'react';

const TradingFeesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="TradingFeesIcon">
    <path
      d="M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 1 1 0 16.666Zm0-1.666a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334Zm-2.917-5h4.584a.417.417 0 1 0 0-.834H8.333a2.083 2.083 0 0 1 0-4.166h.834V5h1.666v1.667h2.084v1.666H8.333a.417.417 0 0 0 0 .834h3.334a2.083 2.083 0 1 1 0 4.166h-.834V15H9.167v-1.667H7.083v-1.666Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default TradingFeesIcon;
